import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from '@mui/material';
import { ConversationPriorityEnum, ConversationFilterEnum } from 'common/enums';
import { omit } from 'lodash';
import React from 'react';
import {
  ConversationsFilterTypeMap,
  mapConversationPriorityColor,
} from 'utils/conversations';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CircleIcon from '@mui/icons-material/Circle';

type Props = {
  conversationPriority: ConversationPriorityEnum;
  onChangeConversationPriority: (newPriority: ConversationPriorityEnum) => void;
};

export default function ChangeConversationPriorityMenu(props: Props) {
  const { conversationPriority, onChangeConversationPriority } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickConversationPriorityOption = (
    newPriority: ConversationPriorityEnum,
  ) => {
    handleClose();
    onChangeConversationPriority(newPriority);
  };

  const options = Object.keys(
    omit(ConversationsFilterTypeMap, [
      ConversationFilterEnum.ALL,
      ConversationFilterEnum.GROUP,
      ConversationFilterEnum.NO_PRIORITY,
      conversationPriority,
    ]),
  );

  return (
    <>
      <IconButton
        aria-label='Alterar prioridade da conversa'
        id='change-priority-button'
        aria-controls={open ? 'change-conversation-priority-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='menu'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='change-conversation-priority-menu'
        MenuListProps={{
          'aria-labelledby': 'change-priority-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              border: '1px solid #CCCCD6',
              borderRadius: '11px',
              padding: '8px 0',
              width: '18ch',
            },
          },
        }}
      >
        <MenuItem
          disableRipple
          sx={{
            pointerEvents: 'none',
            opacity: 1,
            cursor: 'default',
          }}
        >
          <ListItemIcon>
            <InfoOutlinedIcon
              style={{
                fontSize: 14,
              }}
            />
          </ListItemIcon>
          <Typography variant="body2">Classificar como:</Typography>
        </MenuItem>
        {options.map((option: ConversationPriorityEnum) => (
          <MenuItem
            key={option}
            onClick={() => handleClickConversationPriorityOption(option)}
          >
            <ListItemIcon>
              <CircleIcon
                style={{
                  color: mapConversationPriorityColor(option).dark,
                  fontSize: 12,
                }}
              />
            </ListItemIcon>
            <Typography variant="body2">{ConversationsFilterTypeMap[option]()}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
